/**
 * Address Tagging Utilities
 *
 * Provides human-readable labels for known contract addresses
 */
import { MULTISEND_CALL_ONLY, SAFE_MIGRATION, SIGN_MESSAGE_LIB, TRUSTED_MODULES, } from '../security/constants.js';
/**
 * Known address tags
 */
const ADDRESS_TAGS = new Map();
// MultiSendCallOnly contracts
for (const addr of MULTISEND_CALL_ONLY) {
    ADDRESS_TAGS.set(addr.toLowerCase(), {
        label: 'MultiSendCallOnly',
        description: 'Safe batching contract for multiple calls',
        category: 'safe-contract',
    });
}
// Safe Migration contracts
for (const addr of SAFE_MIGRATION) {
    ADDRESS_TAGS.set(addr.toLowerCase(), {
        label: 'SafeMigration',
        description: 'Safe contract migration library',
        category: 'safe-contract',
    });
}
// Sign Message Library contracts
for (const addr of SIGN_MESSAGE_LIB) {
    ADDRESS_TAGS.set(addr.toLowerCase(), {
        label: 'SignMessageLib',
        description: 'Off-chain message signing library',
        category: 'safe-contract',
    });
}
// Trusted modules
for (const addr of TRUSTED_MODULES) {
    ADDRESS_TAGS.set(addr.toLowerCase(), {
        label: 'Allowance Module',
        description: 'Spending limit module for Safe',
        category: 'safe-contract',
    });
}
// Token contracts
ADDRESS_TAGS.set('0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2', {
    label: 'WETH',
    description: 'Wrapped Ether (WETH9)',
    category: 'token',
});
/**
 * Get tag for an address
 *
 * @param address - Address to look up
 * @returns Tag if found, undefined otherwise
 */
export function getAddressTag(address) {
    return ADDRESS_TAGS.get(address.toLowerCase());
}
/**
 * Check if an address has a tag
 *
 * @param address - Address to check
 * @returns True if address is tagged
 */
export function hasAddressTag(address) {
    return ADDRESS_TAGS.has(address.toLowerCase());
}
/**
 * Register a custom address tag
 *
 * @param address - Address to tag
 * @param tag - Tag information
 */
export function registerAddressTag(address, tag) {
    ADDRESS_TAGS.set(address.toLowerCase(), tag);
}
/**
 * Get all tagged addresses
 *
 * @returns Array of [address, tag] pairs
 */
export function getAllAddressTags() {
    return Array.from(ADDRESS_TAGS.entries());
}
//# sourceMappingURL=address-tags.js.map